import { FC } from 'react';
import { TypeBody } from '../Typography';
import Button, { ButtonProps } from '../Button';
import { Container } from 'styled/layouts/container';
import { Grid } from 'styled/layouts/grid';
import {
  Section,
  Frame,
  BookendTitle,
  BookendContent,
  Eyebrow,
} from './bookend.styled';
import { BookendItem } from './bookend-item';

export type aligns = 'start' | 'center' | 'end';

export interface BookendProps {
  media: {
    src: string;
    alt: string;
    width: number;
    height: number;
  };
  title: string;
  titleStyle?: React.CSSProperties;
  pill?: string;
  word?: string;
  eyebrow?: string;
  body: string;
  primaryButton: ButtonProps;
  align?: aligns;
  additionalImage?: {
    src: string;
    alt: string;
    width: number;
    height: number;
  };
}

interface BookendsProps {
  items: BookendProps[];
}

export const Bookend: FC<BookendProps> = ({
  title,
  eyebrow,
  pill,
  body,
  primaryButton,
  media,
  align = 'center',
}) => {
  return (
    <Frame style={{ backgroundImage: `url(${media.src})` }} align={align}>
      {(align === 'center' || align === 'end') && eyebrow && (
        <Eyebrow align={align} className='eyebrow'>
          {eyebrow}
        </Eyebrow>
      )}
      <BookendContent>
        <BookendTitle data-pill={pill}>{title}</BookendTitle>
        <TypeBody color='inverse-primary'>{body}</TypeBody>
        <Button
          label={primaryButton.label}
          url={primaryButton.url}
          color='snowwhite'
        />
      </BookendContent>
    </Frame>
  );
};

export const Bookends: FC<BookendsProps> = ({ items }) => {
  return (
    <Section>
      <Container>
        <Grid>
          {items.map((item, index) => (
            <BookendItem key={index} item={item} index={index} />
          ))}
        </Grid>
      </Container>
    </Section>
  );
};

export default Bookends;
